import { API } from '../constants/Constants';
import { GLOBAL_TOAST } from '../constants/toastConstant';
import Instance from './interceptor';
import Toast from '../components/pages/utils/Toast';

export const logInfo = async (data, flowId) => {
  try {
    const response = await Instance.post(`${API.CREATE_LOGS}`, {
      data,
      flowId,
    });
    return response?.data?.logs;
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: GLOBAL_TOAST.NETWORK_ERROR, variant: 'error' });
    }
  }
};

export const getFlowLogsById = async (id, from, to, page, logsPerPage) => {
  let url = `${API.SINGLE_FLOW_LOGS}?flowId=${id}&page=${page}&limit=${logsPerPage}`;
  try {
    if (from && to) {
      url += `&from=${from}&to=${to}`;
    }
    const response = await Instance.get(url);
    return response?.data;
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: GLOBAL_TOAST.NETWORK_ERROR, variant: 'error' });
    }
  }
};
